import React from 'react';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

const ConfirmationBlock = props => {

    const {
        anyChangesInTaxhouseholdComposition,
        onFieldChange,
        ButtonContainer,
        ...restProps
    } = props;

    return (
        <div className = 'subsection' >
            <UniversalInput
                legend = { {
                    legendText: 'ssap.input.legend.any_changes_in_household'
                } }
                label = { {
                    labelClass: [ 'usa-width-one-whole', 'layout--02' ],
                    ulClass: [ 'usa-width-one-whole margin-b-20' ],
                    showRequiredIcon: true
                } }
                inputData = { {
                    isInputRequired: true,
                    type: INPUT_TYPES.RADIO_BUTTONS,
                    classes: [ 'disp-styl-none' ],
                    name: 'anyChangesInTaxhouseholdComposition',
                    value: anyChangesInTaxhouseholdComposition,
                    options: DROPDOWN_OPTIONS.YES_NO,
                    validationType: VALIDATION_TYPES.CHOSEN,
                    currentData: {},
                    fields: []
                } }
                inputActions = { {
                    onFieldChange
                } }
                indexInArray = { 0 }
                errorClasses = { [ 'margin-l-0' ] }
                { ...restProps }
            />

            {
                anyChangesInTaxhouseholdComposition &&

                <ButtonContainer
                    args = { [ ] }
                    type = 'updateInformationButton'
                />
            }

        </div>
    );
};

export default ConfirmationBlock;
